<template>
    <dialog :open="open" class="action-dialog">
        <h3>Массовые приглашения</h3>
        <label>UUID пользователей (по одному на строку или через запятую)
            <textarea v-model="rawInput" rows="6" placeholder="uuid1&#10;uuid2&#10;..." />
        </label>
        <p class="parsed-count">Распознано: {{ parsedCount }} пользователь(ей)</p>
        <label>Сообщение (необязательно)
            <textarea v-model="message" rows="3" />
        </label>
        <div class="actions">
            <button class="btn btn--primary" :disabled="busy || parsedCount === 0" @click="submit">
                {{ busy ? 'Отправляю…' : `Отправить ${parsedCount} приглашений` }}
            </button>
            <button class="btn" @click="$emit('close')">Назад</button>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ open: boolean; eventId: () => string }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'done'): void }>();

const rawInput = ref('');
const message = ref('');
const busy = ref(false);

const parsedUserPks = computed((): string[] => {
    return rawInput.value
        .split(/[\n,]+/)
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);
});

const parsedCount = computed((): number => parsedUserPks.value.length);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${props.eventId()}/bulk-invite/`,
            data: { user_pks: parsedUserPks.value, message: message.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}
</script>

<style scoped>
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    width: min(480px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.action-dialog textarea {
    width: 100%;
    box-sizing: border-box;
}
.parsed-count {
    font-size: 0.875rem;
    color: var(--admin-text-muted, #666);
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog textarea { font-size: 1rem; }
    .actions .btn { min-height: 2.5rem; }
}
</style>
